import React, { forwardRef } from 'react';
import { Box, Button, IconButton } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { GridCloseIcon } from '@mui/x-data-grid';
import { func, oneOf, string } from 'prop-types';
import palette from 'library/theme/palette';

const CustomerAuthorizationBulkSnackbar = forwardRef(
  ({ message, onClose, onViewDetails, title, variant }, ref) => {
    const isWarning = variant === 'warning';
    const backgroundColor = isWarning
      ? palette._next.alert.warning.background
      : palette._next.alert.light;
    const iconColor = isWarning ? palette._next.alert.warning.icon : palette._next.error.main;
    const textColor = isWarning ? palette._next.alert.warning.color : palette._next.alert.dark;

    return (
      <Box
        ref={ref}
        sx={{
          alignItems: 'flex-start',
          backgroundColor,
          borderRadius: 1,
          boxShadow: 6,
          color: textColor,
          display: 'flex',
          height: 'auto',
          maxWidth: 360,
          padding: 2,
        }}
      >
        {isWarning ? (
          <WarningAmberOutlinedIcon sx={{ color: iconColor, mr: 1.5, mt: '2px' }} />
        ) : (
          <ErrorOutlineIcon sx={{ color: iconColor, mr: 1.5, mt: '2px' }} />
        )}
        <Box sx={{ flex: 1, maxHeight: 220, overflowY: 'auto', pr: 0.5 }}>
          <Box
            sx={{
              fontFamily: 'Overpass',
              fontSize: 16,
              fontWeight: '700',
              lineHeight: 1.43,
              mb: 1,
              mr: 0.5,
              mt: 0.5,
              whiteSpace: 'nowrap',
            }}
          >
            {title}
          </Box>
          <Box sx={{ fontFamily: 'Overpass', fontSize: 14, fontWeight: '500', lineHeight: 1.35 }}>
            {message}
          </Box>
          <Box sx={{ mt: 1 }}>
            <Button color="inherit" onClick={onViewDetails} size="small" variant="text">
              View Details
            </Button>
          </Box>
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={{ color: textColor, ml: 1 }}
        >
          <GridCloseIcon fontSize="small" />
        </IconButton>
      </Box>
    );
  }
);

CustomerAuthorizationBulkSnackbar.displayName = 'CustomerAuthorizationBulkSnackbar';

CustomerAuthorizationBulkSnackbar.propTypes = {
  message: string.isRequired,
  onClose: func.isRequired,
  onViewDetails: func.isRequired,
  title: string.isRequired,
  variant: oneOf(['error', 'warning']).isRequired,
};

export default CustomerAuthorizationBulkSnackbar;
